// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TCd0ik5JHET1EjxubRIU {
  width: 100%;
  height: 100%;
}
.fsZKZJjVRmgeFECQxyj9 {
  padding: 1.5rem 2.125rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixin.less","webpack://./src/pages/me/privacyPolicy/index.less"],"names":[],"mappings":"AA6BA;EACE,WAAA;EACA,YAAA;AC5BF;AAFA;EACE,wBAAA;AAIF","sourcesContent":["@import \"./vars.less\";\n\n.flex() {\n  display: flex;\n}\n\n.flex-row() {\n  display: flex;\n  flex-direction: row;\n}\n\n.flex-row-content(@justifyContent: space-between) {\n  display: flex;\n  flex-direction: row;\n  justify-content: @justifyContent;\n  align-items: center;\n}\n\n.flex-column() {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex-column-content(@justifyContent: space-between) {\n  display: flex;\n  flex-direction: column;\n  justify-content: @justifyContent;\n  align-items: center;\n}\n.imgFull {\n  width: 100%;\n  height: 100%;\n}\n","@import \"@/styles/mixin.less\";\n.wrapper {\n  padding: 24px 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgFull": `TCd0ik5JHET1EjxubRIU`,
	"wrapper": `fsZKZJjVRmgeFECQxyj9`
};
export default ___CSS_LOADER_EXPORT___;
